"use client";

import GlobalNav from "@amzn/rigel-pattern-global-nav";
import "@amzn/aws-marketing-identity-kit-navatar/dist/styles/styles.min.css";
import "@amzn/rigel-pattern-global-nav/dist/styles/bundle.css";
import { useRouter, usePathname } from "next/navigation";
import { NavigationDictionary } from "@/types";
import { EnvironmentStage, Locale, TypeaheadItem } from "@/types/awsm";
import { createLocalizedPath } from "@/lib/utils/utils";
import { AuthProviderV2 } from "@amzn/aws-marketing-identity-kit-essentials";
import {
  availableLanguages,
  languageToLocaleMap,
  localesMap,
} from "@/lib/constants/i18n";
import { convertToLocale } from "@/lib/utils/localeUtils";
import NavatarComponent from "../Navatar/Navatar";

const Navigation = ({
  dictionary,
  typeahead,
  language,
  stage,
}: {
  dictionary: NavigationDictionary;
  typeahead: Record<string, TypeaheadItem[]>;
  language: string;
  stage: string;
}) => {
  const router = useRouter();
  const pathname = usePathname();

  stage = stage === "dev" ? "alpha" : stage;

  const authUrl =
    stage === EnvironmentStage.PROD
      ? "auth.aws.amazon.com"
      : `${stage}.auth-builderprofile.aws.dev`;
  const isProd = stage === "prod";

  return (
    <div className="sticky top-0 z-[6001]">
      <AuthProviderV2
        clientId={`horizon-${stage}`}
        appUrls={{
          tokenAPI: process.env.NEXT_BP_TOKEN_API
            ? process.env.NEXT_BP_TOKEN_API
            : `https://${authUrl}`,
          authAPI: process.env.NEXT_BP_TOKEN_API
            ? process.env.NEXT_BP_TOKEN_API
            : `https://${authUrl}`,
          builderProfileAPI: isProd
            ? "https://api-v2.builderprofile.aws.dev"
            : "https://gamma-api-v2.builderprofile.aws.dev",
        }}
      >
        <GlobalNav
          availableLanguages={availableLanguages as Array<Locale>}
          {...dictionary}
          locale={convertToLocale(languageToLocaleMap[language])}
          navatar={<NavatarComponent key="navatar" language={language} />}
          typeaheadItems={typeahead}
          onLanguageSelect={(_, language) => {
            router.push(
              createLocalizedPath({
                currentPath: pathname,
                newLocale: localesMap[language.code],
                supportedLocales: Object.values(localesMap),
              }),
            );
          }}
        />
      </AuthProviderV2>
    </div>
  );
};

export default Navigation;
